(function () {
  var settings = JSON.parse(document.getElementById('delivery-info-settings')?.textContent || '{}');
  var cutoffs = settings.cutoffs || [0, 0, 0, 0, 0, 0, 0];
  var leadTime = settings.leadTime || 1;
  var workingDays = settings.workingDays || [false, true, true, true, true, true, false];
  var shippingDays = settings.shippingDays || [false, true, true, true, true, true, true];
  var cartLabel = settings.cartLabel || 'Expected delivery date';
  var suffix = settings.suffix || '';
  var labelStatus = settings.labelStatus || 'In Stock';
  var labelOrderBy = settings.labelOrderBy || 'Order Within';
  var labelFor = settings.labelFor || 'For Express Delivery On';
  var bankHolidays = [];
  var cacheKey = 'wa-bank-holidays';
  var cacheTtl = 24 * 60 * 60 * 1000;

  function fetchBankHolidays() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (cached && Date.now() - cached.fetchedAt < cacheTtl) {
        bankHolidays = cached.dates;
        return Promise.resolve();
      }
    } catch (e) {}
    return fetch('https://www.gov.uk/bank-holidays.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        bankHolidays = data['england-and-wales'].events.map(function (e) { return e.date; });
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify({ fetchedAt: Date.now(), dates: bankHolidays }));
        } catch (e) {}
      })
      .catch(function () {});
  }

  function isBankHoliday(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return bankHolidays.includes(y + '-' + m + '-' + d);
  }

  function isShippingDay(date) {
    var d = date.getDay();
    if (isBankHoliday(date)) return false;
    return workingDays[d] && shippingDays[d];
  }

  function nextShippingDay(from) {
    var d = new Date(from);
    d.setDate(d.getDate() + 1);
    while (!isShippingDay(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  function ordinal(n) {
    var s = ['th', 'st', 'nd', 'rd'], v = n % 100;
    var day = String(n).padStart(2, '0');
    return day + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  function formatDate(date) {
    var weekday = date.toLocaleDateString('en-GB', { weekday: 'long' });
    var month = date.toLocaleDateString('en-GB', { month: 'long' });
    return weekday + ' ' + ordinal(date.getDate()) + ' ' + month;
  }

  function formatCountdown(ms) {
    var totalMinutes = Math.floor(ms / 60000);
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    if (hours > 0) return hours + ' hour' + (hours !== 1 ? 's' : '') + ', ' + minutes + ' minute' + (minutes !== 1 ? 's' : '');
    return minutes + ' minute' + (minutes !== 1 ? 's' : '');
  }

  function nextCutoff(from) {
    var d = new Date(from);
    for (var i = 0; i < 8; i++) {
      if (isShippingDay(d)) {
        var h = cutoffs[d.getDay()];
        if (h > 0) {
          var c = new Date(d);
          c.setHours(h, 0, 0, 0);
          if (c > from) return { cutoff: c, dispatchDay: d };
        }
      }
      d = new Date(d);
      d.setDate(d.getDate() + 1);
      d.setHours(0, 0, 0, 0);
    }
    return null;
  }

  function update(el) {
    if (el.dataset.available !== 'true') return;
    var now = new Date();
    var simpleMode = el.dataset.mode === 'simple';

    var next = nextCutoff(now);
    if (!next) { el.textContent = labelStatus; return; }

    var deliveryDate = next.dispatchDay;
    for (var i = 0; i < leadTime; i++) deliveryDate = nextShippingDay(deliveryDate);

    if (simpleMode) {
      el.textContent = cartLabel + ': ' + formatDate(deliveryDate);
      return;
    }

    var remaining = next.cutoff - now;
    el.innerHTML = '<span class="dm-status">' + labelStatus + '</span>'
      + '<span class="dm-sep"> - </span>'
      + '<span class="dm-action">' + labelOrderBy + ' </span>'
      + '<span class="dm-countdown">' + formatCountdown(remaining) + '</span>'
      + '<span class="dm-action"> ' + labelFor + ' </span>'
      + '<span class="dm-date">' + formatDate(deliveryDate) + '</span>'
      + (suffix ? '<span class="dm-suffix"> ' + suffix + '</span>' : '');
  }

  function updateAll() {
    document.querySelectorAll('[data-delivery-info]').forEach(update);
  }

  fetchBankHolidays().then(function () {
    updateAll();
    setInterval(updateAll, 60000);
  });
})();
